type StatusBadgeProps = {
  tone?: string | null;
  children: string;
  subtle?: boolean;
};

export function StatusBadge({ tone = "neutral", children, subtle = false }: StatusBadgeProps) {
  return <span className={`badge badge-${tone || "neutral"}${subtle ? " badge-subtle" : ""}`}>{children}</span>;
}
